<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Programme d'investissement et plan de financement
            </h2>
            <br />
            <wide-card
                title="Immobilisations en non-valeur"
                titleClass="text-center mb-2"
            >
                <multiselect
                    v-model="
                        programmeDinvestissementPlanDeFinancement.nonValueAssetOptions
                    "
                    :options="nonValueAssetOptions"
                    :multiple="true"
                    group-values="libs"
                    group-label="language"
                    :group-select="true"
                    placeholder="Immobilisations en non-valeur"
                    track-by="name"
                    label="name"
                >
                    <span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                    >
                </multiselect>
                <base-number-input
                    v-for="(input,
                    index) in programmeDinvestissementPlanDeFinancement.nonValueAssetOptions"
                    :key="index"
                    :label="input.name + ' :'"
                    placeholder="montant"
                    :isCurrency="true"
                    v-model="input.value"
                    :hasError="
                        $v.programmeDinvestissementPlanDeFinancement
                            .nonValueAssetOptions[`${index}`].$error
                    "
                    :errorMessage="
                        errorMessage(
                            input.name,
                            $v.programmeDinvestissementPlanDeFinancement
                                .nonValueAssetOptions[`${index}`].value
                        )
                    "
                    @blur="
                        $v.programmeDinvestissementPlanDeFinancement.nonValueAssetOptions[
                            `${index}`
                        ].value.$touch()
                    "
                />
                <h2
                    class="mt-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                >
                    Total
                </h2>
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ nonValueAssetTotal }}
                    </h2>
                </div>
            </wide-card>
            <wide-card
                title="Immobilisations incorporelles"
                titleClass="text-center mb-2"
            >
                <multiselect
                    v-model="
                        programmeDinvestissementPlanDeFinancement.intangibleAssetsOptions
                    "
                    :options="intangibleAssetsOptions"
                    :multiple="true"
                    placeholder="Immobilisations incorporelles"
                    track-by="name"
                    label="name"
                >
                    <span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                    >
                </multiselect>
                <base-number-input
                    v-for="(input,
                    index) in programmeDinvestissementPlanDeFinancement.intangibleAssetsOptions"
                    :key="index"
                    :label="input.name + ' :'"
                    :isCurrency="true"
                    placeholder="montant"
                    v-model="input.value"
                    :hasError="
                        $v.programmeDinvestissementPlanDeFinancement
                            .intangibleAssetsOptions[`${index}`].$error
                    "
                    :errorMessage="
                        errorMessage(
                            input.name,
                            $v.programmeDinvestissementPlanDeFinancement
                                .intangibleAssetsOptions[`${index}`].value
                        )
                    "
                    @blur="
                        $v.programmeDinvestissementPlanDeFinancement.intangibleAssetsOptions[
                            `${index}`
                        ].value.$touch()
                    "
                />
                <h2
                    class="mt-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                >
                    Total
                </h2>
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ intangibleAssetsTotal }}
                    </h2>
                </div>
            </wide-card>
            <wide-card
                title="Immobilisations corporelles"
                titleClass="text-center mb-2"
            >
                <multiselect
                    v-model="
                        programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions
                    "
                    :options="tangibleAssetsOptions"
                    :multiple="true"
                    placeholder="Immobilisations corporelles"
                    track-by="name"
                    label="name"
                >
                    <span slot="noResult"
                        >Oops! No elements found. Consider changing the search
                        query.</span
                    >
                </multiselect>
                <base-number-input
                    v-for="(input,
                    index) in programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions"
                    :key="index"
                    :label="input.name + ' :'"
                    :isCurrency="true"
                    placeholder="montant"
                    v-model="input.value"
                    :hasError="
                        $v.programmeDinvestissementPlanDeFinancement
                            .tangibleAssetsOptions[`${index}`].$error
                    "
                    :errorMessage="
                        errorMessage(
                            input.name,
                            $v.programmeDinvestissementPlanDeFinancement
                                .tangibleAssetsOptions[`${index}`].value
                        )
                    "
                    @blur="
                        $v.programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions[
                            `${index}`
                        ].value.$touch()
                    "
                />
                <h2
                    class="mt-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                >
                    Total
                </h2>
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ formatPrice(tangibleAssetsTotal) }}
                    </h2>
                </div>
            </wide-card>
            <wide-card title="Divers et imprévus" titleClass="text-center mb-2">
                <base-number-input
                    placeholder="montant"
                    :isCurrency="true"
                    v-model="
                        programmeDinvestissementPlanDeFinancement.diversImprevue
                    "
                    :hasError="
                        $v.programmeDinvestissementPlanDeFinancement
                            .diversImprevue.$error
                    "
                    :errorMessage="
                        errorMessage(
                            'Divers et imprévus',
                            $v.programmeDinvestissementPlanDeFinancement
                                .diversImprevue
                        )
                    "
                    @blur="
                        $v.programmeDinvestissementPlanDeFinancement.diversImprevue.$touch()
                    "
                />
                <h2
                    class="mt-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                >
                    Total
                </h2>
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{
                            programmeDinvestissementPlanDeFinancement.diversImprevue ===
                            null
                                ? 0
                                : formatPrice(
                                      programmeDinvestissementPlanDeFinancement.diversImprevue
                                  )
                        }}
                    </h2>
                </div>
            </wide-card>
            <wide-card
                title=" Total Programme d'Investissement (HT)"
                titleClass="text-center mb-2"
            >
                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ formatPrice(investorTotal) }}
                    </h2>
                </div>
            </wide-card>
            <wide-card
                title="Plan de financement"
                titleClass="text-center mb-4"
            >
                <div class="grid items-center grid-cols-2 gap-4">
                    <h3 class="text-lg text-blue-600">Capital social</h3>
                    <base-number-input
                        placeholder="montant"
                        :isCurrency="true"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.capitalSocial
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .capitalSocial.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Capital social',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .capitalSocial
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.capitalSocial.$touch()
                        "
                    />
                    <h3 class="text-lg text-blue-600">
                        Apport en comptes courants associés
                    </h3>
                    <base-number-input
                        placeholder="montant"
                        :isCurrency="true"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.compteAssocie
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .compteAssocie.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Apport en comptes courants associés',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .compteAssocie
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.compteAssocie.$touch()
                        "
                    />
                    <template v-for="index in 2">
                        <h3 class="text-lg text-blue-600" :key="index">
                            Crédit bancaire (montant / durée par mois / taux)
                        </h3>
                        <div class="flex" :key="index">
                            <base-number-input
                                placeholder="montant"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].montant
                                "
                                :isCurrency="true"
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].montant
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`]
                                            .montant
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].montant.$touch()
                                "
                            />
                            <base-number-input
                                placeholder="Durée"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[index - 1].duree
                                "
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].duree
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`]
                                            .duree
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].duree.$touch()
                                "
                            />
                            <base-number-input
                                placeholder="Taux"
                                v-model="
                                    programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[index - 1].taux
                                "
                                :hasError="
                                    $v.programmeDinvestissementPlanDeFinancement
                                        .creditBancaire[`${index - 1}`].taux
                                        .$error
                                "
                                :errorMessage="
                                    errorMessage(
                                        'Crédit bancaire',
                                        $v
                                            .programmeDinvestissementPlanDeFinancement
                                            .creditBancaire[`${index - 1}`].taux
                                    )
                                "
                                @blur="
                                    $v.programmeDinvestissementPlanDeFinancement.creditBancaire[
                                        index
                                    ].taux.$touch()
                                "
                            />
                        </div>
                    </template>
                    <h3 class="text-lg text-blue-600">Leasing</h3>
                    <base-number-input
                        placeholder="montant"
                        :isCurrency="true"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.leasing
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement.leasing
                                .$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Leasing',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .leasing
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.leasing.$touch()
                        "
                    />
                    <h3 class="text-lg text-blue-600">Augmentation capital</h3>
                    <base-number-input
                        placeholder="montant"
                        :isCurrency="true"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.augmentationCapital
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .augmentationCapital.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Leasing',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .augmentationCapital
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.augmentationCapital.$touch()
                        "
                    />
                    <h3 class="text-lg text-blue-600">Subventions</h3>
                    <base-number-input
                        placeholder="montant"
                        :isCurrency="true"
                        v-model="
                            programmeDinvestissementPlanDeFinancement.subventions
                        "
                        :hasError="
                            $v.programmeDinvestissementPlanDeFinancement
                                .subventions.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Leasing',
                                $v.programmeDinvestissementPlanDeFinancement
                                    .subventions
                            )
                        "
                        @blur="
                            $v.programmeDinvestissementPlanDeFinancement.subventions.$touch()
                        "
                    />
                </div>
                <h2
                    class="text-xl font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
                >
                    Total Plan Financement (HT)
                </h2>

                <div class="flex items-center bg-gray-300">
                    <h2 class="p-2 text-lg font-extrabold leading-9">
                        {{ formatPrice(capitalSocialTotal) }}
                    </h2>
                </div>
            </wide-card>

            <base-primary-button title="Suivant" @click="addPlanFinancement" />
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import { mapState, mapGetters } from "vuex";
import {
    decimal,
    minValue,
    requiredIf,
    required
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";
import { formatPriceMixin } from "@/mixins/helpersMixin.js";

export default {
    components: { WideCard },

    mixins: [errorMessage, scrollToError, formatPriceMixin],

    validations() {
        let formValidation = {
            diversImprevue: { decimal, minValue: minValue(0) },
            capitalSocial: { required, decimal, minValue: minValue(0) },
            compteAssocie: { decimal, minValue: minValue(0) },

            leasing: { decimal, minValue: minValue(0) },
            augmentationCapital: { decimal, minValue: minValue(0) },
            subventions: { decimal, minValue: minValue(0) }
        };

        let nonValueAssetValidation = {};
        if (
            this.programmeDinvestissementPlanDeFinancement.nonValueAssetOptions
                .length !== 0
        ) {
            let nonValueAssetRepeater = this.programmeDinvestissementPlanDeFinancement.nonValueAssetOptions.map(
                (input, index) => {
                    return {
                        [`${index}`]: {
                            value: {
                                required,
                                minValue: minValue(1)
                            }
                        }
                    };
                }
            );

            nonValueAssetValidation = {
                ...Object.assign({}, ...nonValueAssetRepeater)
            };
        }

        let intangibleAssetsValidation = {};
        if (
            this.programmeDinvestissementPlanDeFinancement
                .intangibleAssetsOptions.length !== 0
        ) {
            let intangibleAssetsRepeater = this.programmeDinvestissementPlanDeFinancement.intangibleAssetsOptions.map(
                (input, index) => {
                    return {
                        [`${index}`]: {
                            value: {
                                required,
                                minValue: minValue(1)
                            }
                        }
                    };
                }
            );

            intangibleAssetsValidation = {
                ...Object.assign({}, ...intangibleAssetsRepeater)
            };
        }

        let tangibleAssetsValidation = {};
        if (
            this.programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions
                .length !== 0
        ) {
            let tangibleAssetsRepeater = this.programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions.map(
                (input, index) => {
                    return {
                        [`${index}`]: {
                            value: {
                                required,
                                minValue: minValue(1)
                            }
                        }
                    };
                }
            );

            tangibleAssetsValidation = {
                ...Object.assign({}, ...tangibleAssetsRepeater)
            };
        }

        let creditBancaireValidation = {};

        if (
            this.programmeDinvestissementPlanDeFinancement.creditBancaire
                .length !== 0
        ) {
            let creditBancaireRepeater = this.programmeDinvestissementPlanDeFinancement.creditBancaire.map(
                (input, index) => {
                    const check = () => {
                        if (
                            this.programmeDinvestissementPlanDeFinancement
                                .creditBancaire[index].montant === null ||
                            this.programmeDinvestissementPlanDeFinancement
                                .creditBancaire[index].montant === 0
                        )
                            return false;
                        return true;
                    };
                    return {
                        [`${index}`]: {
                            montant: { decimal, minValue: minValue(0) },
                            duree: {
                                decimal,
                                minValue: check() ? minValue(1) : minValue(0),
                                required: requiredIf(check)
                            },
                            taux: {
                                decimal,
                                minValue: minValue(0),
                                required: requiredIf(check)
                            }
                        }
                    };
                }
            );

            creditBancaireValidation = {
                ...Object.assign({}, ...creditBancaireRepeater)
            };
        }

        formValidation = {
            ...formValidation,
            tangibleAssetsOptions: tangibleAssetsValidation,
            intangibleAssetsOptions: intangibleAssetsValidation,
            creditBancaire: creditBancaireValidation,
            nonValueAssetOptions: nonValueAssetValidation
        };

        return {
            programmeDinvestissementPlanDeFinancement: formValidation
        };
    },
    created() {
        console.log(this.investmentProgramme);
        this.programmeDinvestissementPlanDeFinancement = this.investmentProgramme;
        this.$store.dispatch("forms/showSection", "Étude Financiere");
        this.$store.dispatch(
            "forms/stepFocus",
            "Programme d’investissement plan de financement"
        );
    },
    data() {
        return {
            programmeDinvestissementPlanDeFinancement: {}
        };
    },
    methods: {
        addPlanFinancement() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                if (this.investorTotal === this.capitalSocialTotal) {
                    this.$store.dispatch("EtudeFinanciere/addPlanFinancement", {
                        ...this.programmeDinvestissementPlanDeFinancement,
                        nonValueAssetTotal: this.nonValueAssetTotal,
                        intangibleAssetsTotal: this.intangibleAssetsTotal,
                        tangibleAssetsTotal: this.tangibleAssetsTotal
                    });
                    this.$store.dispatch(
                        "EtudeFinanciere/SaveInvestorsProgramme"
                    );
                    this.$store.dispatch(
                        "forms/subStepComplete",
                        "Programme d’investissement plan de financement"
                    );

                    this.$router.push({
                        name: "chiffres_daffaires_previsionnels",
                        params: { uid: `${this.$store.state.user.bpiId}` }
                    });
                } else {
                    this.$emit("showNotification", {
                        error: true,
                        content:
                            "Votre plan d'investissement doit être égal au plan financement. Merci de bien vouloir vérifier à nouveau vos informations.",
                        title: "Attention"
                    });
                }
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        }
    },
    computed: {
        ...mapGetters("EtudeFinanciere", ["investmentProgramme"]),

        ...mapState("forms", {
            nonValueAssetOptions: state =>
                state.ProgrammeDinvestissementPlanDeFinancement
                    .nonValueAssetOptions,
            intangibleAssetsOptions: state =>
                state.ProgrammeDinvestissementPlanDeFinancement
                    .intangibleAssetsOptions,
            tangibleAssetsOptions: state =>
                state.ProgrammeDinvestissementPlanDeFinancement
                    .tangibleAssetsOptions
        }),

        nonValueAssetTotal() {
            if (this.programmeDinvestissementPlanDeFinancement === undefined)
                return 0;
            if (
                this.programmeDinvestissementPlanDeFinancement
                    .nonValueAssetOptions.length === 1
            )
                return this.programmeDinvestissementPlanDeFinancement
                    .nonValueAssetOptions[0].value;
            return this.programmeDinvestissementPlanDeFinancement.nonValueAssetOptions.reduce(
                (a, b) => a + parseInt(b.value),
                0
            );
        },
        intangibleAssetsTotal() {
            if (
                this.programmeDinvestissementPlanDeFinancement
                    .intangibleAssetsOptions.length === 1
            )
                return this.programmeDinvestissementPlanDeFinancement
                    .intangibleAssetsOptions[0].value;
            return this.programmeDinvestissementPlanDeFinancement.intangibleAssetsOptions.reduce(
                (a, b) => a + parseInt(b.value),
                0
            );
        },
        tangibleAssetsTotal() {
            if (
                this.programmeDinvestissementPlanDeFinancement
                    .tangibleAssetsOptions.length === 1
            )
                return this.programmeDinvestissementPlanDeFinancement
                    .tangibleAssetsOptions[0].value;
            return this.programmeDinvestissementPlanDeFinancement.tangibleAssetsOptions.reduce(
                (a, b) => a + parseInt(b.value),
                0
            );
        },
        capitalSocialTotal() {
            const investorObject = this
                .programmeDinvestissementPlanDeFinancement;
            let total = 0;
            total += investorObject?.capitalSocial ?? 0;
            total += investorObject?.compteAssocie ?? 0;
            total += investorObject?.augmentationCapital ?? 0;
            total += investorObject?.subventions ?? 0;
            total += investorObject?.leasing ?? 0;
            total += investorObject.creditBancaire.reduce(
                (sum, creditBancaire) => {
                    return (creditBancaire?.montant ?? 0) + sum;
                },
                0
            );
            return total;
        },
        investorTotal() {
            return (
                this.nonValueAssetTotal +
                this.intangibleAssetsTotal +
                this.tangibleAssetsTotal +
                this.programmeDinvestissementPlanDeFinancement.diversImprevue
            );
        }
    }
};
</script>

<style></style>
